module.exports = __webpack_public_path__ + "static/media/andjce-formulaire-candidature-bourse.30557761.pdf";